import React, {useRef, useState} from 'react';
import {PresetDM} from "../interfaces";
import LinkIcon from "../../../../ui/svg/common/link";
import DragAndDropIcon from "../../../../ui/svg/common/drag-and-drop";
import {isMobile, isTablet} from "../../../../domain/common";
import VisitChainArrowIcon from "../svg/visit-chain-arrow";
import {sendGAEvent} from "../../../../domain/marketing/gtm-provider";
import AudioBase64 from "../../../galleries/audio-base64/audio-base64";
import {AudioBase64StyleEnum} from "../../../galleries/audio-base64/interfaces";


export interface IPresetVisitChainProps {
    preset:PresetDM;
    presetListRef?:any;
    setShowLinkCopiedPopup:Function;
}

const PresetVisitChain = (props:IPresetVisitChainProps) => {
    const [hoverAudioBase64, setHoverAudioBase64] = useState(false);
    const [showLinkBubble, setShowLinkBubble] = useState(false);
    const [showDragAndDropBubble, setShowDragAndDropBubble] = useState(false);
    const [popUpInsideScreen, setPopUpInsideScreen] = useState(true);
    const containerRef = useRef<HTMLDivElement>(null);
    const isMobileScreen = isMobile() || isTablet();

    const chainFullLink = "https://" + window.location.hostname + "/studioverse/chain/" + props.preset.presetGUID;
    const SpeechBubbleWidth = 230;//230px

    /*
        Bug fix --> when speech bubble overflows the preset list from the right
    */
    const OnMouseOverSetPopUpInsideScreen = () =>{
        if (props.presetListRef !== undefined && containerRef.current !== null) {
            const rect = containerRef.current.getBoundingClientRect();
            const presetListRect = props.presetListRef.current.getBoundingClientRect();

            if (rect.right + SpeechBubbleWidth > presetListRect.right) {
                //If (right position of buttons) + (popup width) is bigger than the preset list container's right --> expand speech bubble to the left
                setPopUpInsideScreen(false);
            }else{
                setPopUpInsideScreen(true);
            }
        }
    }

    /*mouse AudioBase64*/
    const mouseOverAudioBase64 = (evnt:any) => {
        setHoverAudioBase64(true);
        setShowLinkBubble(false);
        setShowDragAndDropBubble(false);
    }
    const mouseOutAudioBase64 = (evnt:any) => {
        setHoverAudioBase64(false);
    }

    /*mouse Link*/
    const mouseOverLink = (evnt:any) => {
        OnMouseOverSetPopUpInsideScreen();
        setShowLinkBubble(true);
        setHoverAudioBase64(false);
        setShowDragAndDropBubble(false);

    }
    const mouseOutLink = (evnt:any) => {
        setShowLinkBubble(false);
    }

    const dragLink = (evnt:any) => {
        evnt.dataTransfer?.setData("text/plain", chainFullLink);
        evnt.dataTransfer.setData("text/uri-list", chainFullLink);
        evnt.dataTransfer.effectAllowed = "copy";
    }

    /*mouse DragAndDrop*/
    const mouseOverDragAndDrop = (evnt:any) => {
        OnMouseOverSetPopUpInsideScreen();

        setHoverAudioBase64(false);
        setShowLinkBubble(false);
        setShowDragAndDropBubble(true);

    }
    const mouseOutDragAndDrop = (evnt:any) => {

        setShowDragAndDropBubble(false);

    }
    const mouseOut = (evnt:any) => {
        //mouseOutDragAndDrop(evnt);
        //mouseOutLink(evnt);
        //mouseOutAudioBase64(evnt);
    }
    const copyLinkToClipboard = async () => {

        await navigator.clipboard.writeText(chainFullLink);
        props.setShowLinkCopiedPopup(true);

    }
    const onClickPreset = () => {
        sendGAEvent("SV Widget","Widget Chain: " + props.preset.presetName );
        window.location.href = "/studioverse/chain/" + props.preset.presetGUID;
    }
    return (
        <>
            <div className="no-underline cursor-pointer"  onClick={onClickPreset} aria-label={`${props.preset.presetName} Visit Chain Link`}>
                <div className="absolute top-0 flex items-center justify-center w-full h-full z-10" >
                        <div className="border border-white rounded-full text-white py-2 px-5 flex items-center">
                            <span className="pr-2">Visit Chain</span>
                            <div className="">
                                <VisitChainArrowIcon width="7px" color="white"/>
                            </div>
                        </div>
                </div>
            </div>
            <div className="w-full absolute z-50 bottom-0 right-0 text-black" onMouseLeave={mouseOut} ref={ containerRef }>
                <div className="flex items-center p-3 justify-between">
                    {
                        !props?.preset.audioDemo &&
                        <div className=""></div>
                    }
                    {
                        props?.preset.audioDemo &&
                        <div className={`relative z-50 rounded-full ${hoverAudioBase64 ? "chain-action-gradient-circle-border" : ""} mr-3 cursor-pointer`}
                             onMouseEnter={mouseOverAudioBase64}
                             onMouseLeave={mouseOutAudioBase64}>
                            <AudioBase64 elId={props.preset.presetGUID}
                                         presetGuid={props.preset.presetGUID}
                                         buttonStyle={AudioBase64StyleEnum.IconStyle}
                                         buttonBgColor={hoverAudioBase64 ? "#000000" : "#ffffff"}
                                         buttonColor={hoverAudioBase64 ? "#ffffff" : "#000000"}
                            ></AudioBase64>
                            <audio id={"pb64_" + props.preset.presetGUID} />
                        </div>
                    }
                    <div className="w-auto flex justify-end">
                    {!isMobileScreen &&
                        <div className="relative z-50"
                             onMouseEnter={mouseOverDragAndDrop}
                             onMouseLeave={mouseOutDragAndDrop}>
                            <div
                                className={`${popUpInsideScreen ? "speech-bubble-right-container" : "speech-bubble-left-container"}`}>
                                {showDragAndDropBubble &&
                                    <div
                                        className={`bg-white p-3 rounded shadow-md shadow-gray-500/50 ${popUpInsideScreen ? "speech-bubble-right" : "speech-bubble-left"}`}>

                                        {
                                            props.preset.algType === 'WSCR' &&
                                            <div className="w-full">Drag & drop this button directly into StudioVerse Audio Effects.</div>
                                        }

                                        {
                                            props.preset.algType === 'WSCI' &&
                                            <div className="w-full">Drag & drop this button directly into StudioVerse Instruments.</div>
                                        }
                                    </div>
                                }
                            </div>

                        <div
                            className={`rounded mr-3 p-1.5 cursor-pointer ${showDragAndDropBubble ? "bg-gray-600  chain-action-gradient-border" : "bg-white"}`}
                            draggable="true" onDragStart={dragLink}>
                            <DragAndDropIcon width={"17px"} color={showDragAndDropBubble ? "white" : "black"}/>
                        </div>

                    </div>
                    }
                    <div className="relative"
                         onMouseEnter={mouseOverLink}
                        onMouseLeave={mouseOutLink}>
                        <div
                            className={`${popUpInsideScreen ? "speech-bubble-right-container" : "speech-bubble-left-container"}`}>
                            {showLinkBubble &&
                                <div
                                    className={`bg-white p-3 pr-2 rounded shadow-md shadow-gray-500/50 ${popUpInsideScreen ? "speech-bubble-right" : "speech-bubble-left"}`}>
                                    <div className="w-full">Copy & Paste this link in your StudioVerse plugin search bar.</div>
                                </div>
                            }
                        </div>

                        <div
                            className={`rounded p-1.5 cursor-pointer ${showLinkBubble ? "bg-gray-600 chain-action-gradient-border" : "bg-white"}`}
                            style={{}} onClick={copyLinkToClipboard}>
                            <LinkIcon width={"17px"} color={showLinkBubble ? "white" : "black"}/>
                        </div>
                    </div>
                    </div>

                </div>

            </div>

        </>


    )
};

export default PresetVisitChain;